<!--
 * @Author: LZT
 * @Date: 2024-12-12 14:05:51
 * @LastEditors: ITDLCL
 * @Description:头部导航
 * @FilePath: \qs\src\components\Layout\HeaderNav.vue
-->
<template>
  <!-- :style="{ backgroundColor: `rgba(0,0,0,${opacity})` }" -->
  <div
    class="header__nav"
    :class="[routeMeta.customClass]"
    :style="{ backgroundColor: navStyle == 'fff' ? '#fff' : '#F80F39' }"
  >
    <div :style="{ height: barHeight + 'px' }" />
    <van-nav-bar
      :safe-area-inset-top="barHeight < 1"
      :title="props.titelText"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :style="{
        '--van-nav-bar-background': navStyle == 'fff' ? '#fff' : '#F80F39',
        '--van-nav-bar-title-text-color': navStyle == 'fff' ? '#000' : '#fff',
        '--van-hairline--color': navStyle == 'fff' ? '#E9E9E9' : 'transparent'
      }"
    >
      <template v-if="!routeMeta.showFooter && props?.leftArrow" #left>
        <div class="header__nav_left">
          <img src="@/assets/images/home/left_black_icon.png" alt="" v-if="navStyle == 'fff'" />
          <img src="@/assets/images/home/left_icon.png" alt="" v-else />
        </div>
      </template>

      <template #title v-if="props.isCustom">
        <div
          class="custom-title-content"
          :class="!isHideSwitch ? '' : 'flex-center'"
        >
          <img
            src="@/assets/images/header/left.png"
            class="header-img"
            @click="clickSwitchStock(1)"
            v-if="!isHideSwitch"
          />
          <div class="custom-title">
            {{ props.titelText }}
            <span v-if="props.stock">{{ props.stock.split(".")[0] }}</span>
            <span v-if="props.titelText == '营业部详情'">{{
              props.businessName
            }}</span>
          </div>
          <img
            src="@/assets/images/header/right.png"
            class="header-img"
            @click="clickSwitchStock(2)"
            v-if="!isHideSwitch"
          />
        </div>
      </template>
      <template #right>
        <div v-if="props?.rightArrow">
          <img
            class="search_white_icon"
            v-if="rightIcon === 'search'"
            :src="search_white_icon"
          />
          <template v-else-if="rightIcon == 'setting'">
            <van-popover :actions="settingList" placement="bottom-end" @select="onSettingSelect">
              <template #reference>
                <img
                  class="search_white_icon marginTop6"
                  :src="my_setting_icon"
                />
              </template>
            </van-popover>
          </template>
          <div v-else class="rightIconText" :style="{ color: navStyle == 'fff' ? '#000' : '#fff' }">{{ rightIcon }}</div>
        </div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script setup name="headerNav">
import { nextTick, getCurrentInstance } from "vue";
const router = useRouter();
import useUsersStore from "@/stores/user";
import { openNativeClosePage } from "@/utils/native/gn";
const emit = defineEmits(["goBack", "onClickRight", "clickSwitchStock", "onSettingClickRight"]);
import search_white_icon from "@/assets/images/stocksQuotation/search_white_icon.png";
import my_setting_icon from "@/assets/images/my/my_setting_icon.png";
import { useAdhibitionStore } from "@/stores/adhibition";
const adhibitionStore = useAdhibitionStore();
const userStore = useUsersStore();
const { proxy } = getCurrentInstance();

const props = defineProps({
  leftArrow: {
    type: Boolean,
    default: true
  },
  rightArrow: {
    type: Boolean,
    default: true
  },
  slefBack: {
    // 是否时自定义返回方法
    type: Boolean,
    default: false
  },
  titelText: {
    type: String,
    default: ""
  },
  isCustom: {
    // 是否是自定义标题，用于个股详情，指数详情，板块详情
    type: Boolean,
    default: false
  },
  stock: {
    // 股票code
    type: String,
    default: ""
  },
  businessName: {
    // 营业部名称
    type: String,
    default: ""
  },
  routeMeta: {
    type: Object,
    default: () => {
      return {
        customClass: ""
      };
    }
  },
  isHideSwitch: {
    // 是否隐藏切换股票按钮，目前当从搜索页面点击进入详情页时，隐藏切换按钮
    type: Boolean,
    default: false
  },
  sourceType: {
    type: String,
    default: ""
  },
  // 右侧icon 兼容 我的页面
  rightIcon: {
    type: String,
    default: "search"
  },
  // 导航栏风格 red红底白字 fff白底黑字
  navStyle: {
    type: String,
    default: "red"
  }
});
const barHeight = computed(() => userStore.barHeight);
const opacity = ref(0);
const uniStatus = ref(false);
// 兼容我的页面
const settingList = reactive([
  { id: 1, text: "退出登录" },
  { id: 2, text: "刷新权益" }
]);

// 兼容我的页面
const onSettingSelect = (event) => {
  emit("onSettingClickRight", event);
};
// 左边返回
const onClickLeft = () => {
  if (props?.leftArrow) {
    if (props.sourceType == "gn") {
      openNativeClosePage();
    } else if (props.sourceType == "qsuniapp") {
      if (props?.slefBack) {
        emit("goBack");
      } else {
        if (window.location.href.indexOf("qsuniapp") > -1) {
          try {
            uni.navigateBack({
              delta: 1
            });
          } catch (error) {
            console.error("跳转错误：", error);
          }
        } else {
          router.go(-1);
        }
      }
    } else {
      if (props?.slefBack) {
        emit("goBack");
        proxy.$emitter.emit("layoutClickLeft");
      } else {
        if (window.location.href.indexOf("stockDetail/index") > -1) {
          window.localStorage.setItem("vanTabsActive", "");
        }
        // 检查是否有历史记录
        if (window.history.length > 1) {
          router.go(-1);
        } else {
          // 没有历史记录，跳转到首页
          router.push({
            path: "/home/index",
            query: { timeKey: new Date().getTime() }
          });
        }
      }
    }
  }
};

// 右边返回
const onClickRight = () => {
  emit("onClickRight");
  // 同时触发全局事件
  proxy.$emitter.emit("layoutClickRight");
};

// 切换股票
const clickSwitchStock = switchType => {
  emit("switchStock", switchType);
};

// 滚动
function scrollHandle(e) {
  var top =
    document.body.scrollTop ||
    document.documentElement.scrollTop ||
    window.pageYOffset;
  if (top <= 0 && window.hmFirst) {
    top = document.querySelector("#app").scrollTop;
  }
  if (top < 44) {
    opacity.value = top / 44;
  } else {
    opacity.value = 1;
  }
}

onMounted(() => {
  window.addEventListener("scroll", scrollHandle, true);
  nextTick(() => {
    // 初始化uni.webview
    try {
      document.addEventListener("UniAppJSBridgeReady", function () {
        uniStatus.value = true;
      });
    } catch (error) {
      console.error("UniAppJSBridgeReady:", error);
    }
  });
});
</script>
<style lang="scss" scoped>
.marginTop6 {
  margin-top: 6px;
}
:deep(.van-nav-bar__content) {
  height: 46px;
}

:deep(.van-nav-bar__title) {
  color: var(--van-nav-bar-title-text-color);
  font-size: 18px;
  height: 46px;
  line-height: 46px;
}

:deep(.van-hairline--bottom:after) {
  border-bottom: 1px solid var(--van-hairline--color);
}

:deep(.van-nav-bar__left) {
  padding-left: 15px;
  padding-right: 12px;
}
:deep(.van-nav-bar__right) {
  padding-left: 12px;
  padding-right: 15px;
}

:deep(.van-nav-bar) {
  background: var(--van-nav-bar-background);
}
.search_white_icon {
  width: 24px;
  height: 24px;
  display: block;
}
.rightIconText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  line-height: 18px;
  font-style: normal;
}
.header__nav {
  position: fixed;
  z-index: 100;
  top: 0;
  width: 100%;
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-height: 46px;
  .custom-title-content {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 18px;
    font-style: normal;
    .custom-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 17px;
      }
    }
    .header-img {
      width: 30px;
      height: 30px;
    }
  }

  .flex-center {
    justify-content: center;
  }

  .header__nav_left {
    img {
      width: 24px;
      height: 24px;
      display: block;
    }
  }
}

// 标题居左
.header__nav.text-left:not(.hide-left) {
  .van-nav-bar__title {
    margin: 0 0 0 48px;
  }
}

.header__nav.transparent-bg {
  .van-nav-bar {
    background: transparent;
  }
}
</style>
